export default "__VITE_ASSET__HLN0luXw__"